module.exports = __webpack_public_path__ + "img/1558818219.e5b81ced.jpg";